export default "__VITE_ASSET__QVv40$gv__"